import { render, staticRenderFns } from "./QuAdd.vue?vue&type=template&id=8679f360&scoped=true"
import script from "./QuAdd.vue?vue&type=script&lang=js"
export * from "./QuAdd.vue?vue&type=script&lang=js"
import style0 from "./QuAdd.vue?vue&type=style&index=0&id=8679f360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8679f360",
  null
  
)

export default component.exports